import {
  RESET_LIST_NOTIFICATIONS_REQUESTED,
  RESET_LIST_NOTIFICATIONS_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_LIST_NOTIFICATIONS_REQUESTED,
  });

  dispatch({
    type: RESET_LIST_NOTIFICATIONS_COMPLETED,
  });
};

export default resetAction;
